import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ssr-chip',
  templateUrl: './ssr-chip.component.html',
  styleUrls: ['./ssr-chip.component.scss'],
})
export class SsrChipComponent {}
